// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + "95c19491ac4e3c0f8e7b" + ".chunk.js";
};